import type { GameState, Unit } from "@dailywars/core/engine";

import { buildUnitSelection } from "#/game/selection/transitions";
import type { StoreState } from "#/game/store/types";

function unmovedOwnUnits(state: GameState): Unit[] {
  return state.units
    .filter((unit) => unit.owner === state.currentPlayer && unit.owner === "p1" && !unit.hasMoved)
    .sort((a, b) => a.id.localeCompare(b.id));
}

function nextIndexAfterMissingUnit(units: Unit[], missingUnitId: string): number {
  const nextGreaterIndex = units.findIndex((unit) => unit.id.localeCompare(missingUnitId) > 0);
  if (nextGreaterIndex >= 0) return nextGreaterIndex;
  return 0;
}

export function cycleUnmovedUnitSelection(state: StoreState): StoreState {
  const units = unmovedOwnUnits(state.localState);
  if (units.length === 0) {
    return { ...state, lastCycledUnitId: null };
  }

  let nextIndex = 0;
  const selection = state.selection;
  const currentUnitId =
    selection.mode === "unit" || selection.mode === "move-preview"
      ? selection.unitId
      : state.lastCycledUnitId;

  if (currentUnitId) {
    const currentIndex = units.findIndex((unit) => unit.id === currentUnitId);
    if (currentIndex >= 0) {
      nextIndex = (currentIndex + 1) % units.length;
    } else {
      nextIndex = nextIndexAfterMissingUnit(units, currentUnitId);
    }
  }

  const unit = units[nextIndex]!;
  return {
    ...state,
    lastCycledUnitId: unit.id,
    selection: buildUnitSelection(state.localState, unit),
    previewAnimation: null,
    scrollFocusTile: unit.pos,
  };
}
